<ng-container *ngIf="pick">
    <div class="betslip-digital-bet-pick-column-0">
        <bs-digital-combo-prevention-indicator [pick]="pick" [betslipType]="betslipType"></bs-digital-combo-prevention-indicator>
    </div>
    <div class="betslip-digital-bet-pick-column-1 {{ pickClass }}">
        <ng-container *ngTemplateOutlet="pickTemplate; context: { pick: pick, betslipType: betslipType, messages: messages }"></ng-container>
        <bs-digital-pick-odds [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-pick-odds>
    </div>
    <div class="betslip-digital-bet-pick-column-2">
        <bs-digital-pick-remove-button (remove)="removePick()"></bs-digital-pick-remove-button>
    </div>
</ng-container>
